module.exports = __webpack_public_path__ + "images/multitankcard733af7634b667b244a4f17acc705c56a.png";